import * as React from "react";
import {Badge, ButtonGroup} from "react-bootstrap";
import IconButton from "../../components/button/IconButton";
import { useModels } from "../../helpers/models";
import renderUtils from "../../helpers/renderUtils";
import moment from "moment";
import { useTranslation } from 'react-i18next';

const useFormatDeletedTableConfig = () => {
    const { t } = useTranslation();
    const models = useModels();
    
    return [
        {
            field: "id",
            label: t("common.id"),
            sort: "desc",
            type: "badge",
            badgeType: "badge-primary",
            width: 53,
            // type:"badge"
        },
        {
            field: "nameAndDose",
            label: t("common.name_and_dose"),
            sort: "desc",
            width: 53,
        },
        {
            label: t("common.introduction_date"),
            field: "creationStartDate",
            sort: "desc",
            width: 53,
        },
        {
            label: t("common.withdrawal_date"),
            field: "withdrawalDate",
            sort: "desc",
            width: 53,
        },
        {
            label: t("common.user_withdrawn"),
            field: "withdrawalUser",
            sort: "desc",
            width: 53,
        },
        {
            field: "partsCount",
            label: t("common.parts_count"),
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return row.formatParts ?
                    <Badge className={"outline-secondary font-max"}>{row.formatParts?.length}</Badge> : ""
            }
        },
        {
            field: "formatStatus",
            label: t("common.status"),
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return renderUtils.renderStatus(row.formatStatus, null, null, t);
            }
        },
        {
            field: "actions",
            label: t("common.actions"),
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, reload, setReload, setLoader) {
                return <ButtonGroup>
                    <IconButton
                        variant={"outline-primary"}
                        // className="btn-circle ml-1"
                        onClick={() => history.push("/format/" + row.id)}
                        size={"md"}
                        tooltip={t("common.details")}
                        icon={models.format.icon}
                    />
                    {/*{row.formatParts.length > 0 &&*/}
                    {/*    <IconButton*/}
                    {/*        variant={"outline-primary"}*/}
                    {/*        // className="btn-circle ml-1"*/}
                    {/*        onClick={() => history.push(models.management.url + "/" + row.id)}*/}
                    {/*        size={"md"}*/}
                    {/*        tooltip={models.management.title}*/}
                    {/*        icon={"fa-bars-progress"}*/}
                    {/*    />*/}
                    {/*}*/}

                </ButtonGroup>
            }
        }


    ]
};

export default useFormatDeletedTableConfig;